var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5041 33.9978C12.5041 35.103 11.607 36 10.5019 36H7.85506C6.74987 36 5.85278 35.105 5.85278 33.9978C5.85278 32.8926 6.74987 31.9955 7.85506 31.9955H10.5019C11.607 31.9955 12.5041 32.8926 12.5041 33.9978Z",
    fill: "#F9839A",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1028 33.9978C35.1028 35.103 34.2078 36 33.1006 36H30.4517C29.3465 36 28.4495 35.105 28.4495 33.9978C28.4495 32.8926 29.3465 31.9955 30.4517 31.9955H33.1006C34.2057 31.9955 35.1028 32.8926 35.1028 33.9978Z",
    fill: "#F9839A",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9977 23.1442C35.9977 25.274 34.5833 27 32.8402 27H8.15758C6.41445 27 5 25.274 5 23.1442V7.85578C5 5.72837 6.41445 4 8.15758 4H32.8424C34.5856 4 36 5.72597 36 7.85578V23.1442H35.9977Z",
    fill: "#F5FBFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.475 23.2893C36.475 25.435 35.0162 27.1746 33.216 27.1746H7.74008C5.93985 27.1746 4.48108 25.435 4.48108 23.2893V7.88534C4.48108 5.73961 5.93985 4 7.74008 4H33.214C35.0142 4 36.473 5.73961 36.473 7.88534V23.2893H36.475Z",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85278 16.5834H15L17.9351 7.19434L22.7438 23.9803C22.6509 23.7621 25 16.0197 25 16.0197L35.1029 15.9752",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9557 29.9912C36.9557 31.5469 35.6949 32.8097 34.1371 32.8097H6.81652C5.26077 32.8097 4 31.549 4 29.9932C4 28.4375 5.26077 27.1747 6.81854 27.1747H34.1392C35.6949 27.1747 36.9577 28.4354 36.9577 29.9932L36.9557 29.9912Z",
    fill: "white",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMonitor);
export default __webpack_public_path__ + "static/media/Ic_monitor.c190950ad30e04e276911b0ca49495d6.svg";
export { ForwardRef as ReactComponent };